// extracted by mini-css-extract-plugin
module.exports = {"bg":"_1V_Js","inlineContent":"_3eZL5","pageWrapper":"_3SpWc","root":"_2waFs"};